import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app/App'
import './styles/base.css'

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <StrictMode>
      <div className="sp-glow" />
      <div className="sp-grain" />
      <App />
    </StrictMode>,
  )
}
